import styled from 'styled-components';
import {textSizes} from '@stencil/build-theme';

export const MainWrapper = styled.div`
  ${props =>
    props.$isMweb
      ? `position: relative;
  background: #ffffff;
  border-top: 0.1rem solid rgba(194, 194, 194, 0.3);
  margin-top: 1.2rem;`
      : `border: 0.1rem solid #e4e4e4;
  padding: 1.2rem;
  border-radius: 1.6rem;
  margin:1rem 0;
  background: #fff;`}
`;

export const HeaderPill = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0.6rem;
  margin: auto;
  width: 4rem;
  height: 0.4rem;
  background: #cbcbcb;
  border-radius: 0.8rem;
`;

export const HeaderWrapper = styled.div`
  overflow: hidden;
  padding: ${props => (props.$isMweb ? '1.6rem 0 1.2rem' : `0 0 1.2rem`)};
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.4rem;
`;

export const HeaderText = styled.p`
  color: #717171;
  ${textSizes.SmallW1};
  display: flex;
  align-items: center;
  text-transform: uppercase;
  margin-right: 0.4rem;
`;

export const HeaderGradientLine = styled.div`
  width: 5.6rem;
  height: 0.1rem;
  background: linear-gradient(296.56deg, rgba(255, 255, 255, 0) 33.33%, #ff9f7c 100%);
  /* transform: rotate(180deg); */
`;

export const goTribeIcon = styled.img`
  width: ${props => (props.$isMweb ? '6.9rem' : '10rem')};
`;
export const ItemIcon = styled.img`
  width: 4.2rem;
`;

export const FeatureListWrapper = styled.div`
  overflow: hidden;
`;

export const GoTribeBenefitsWrapper = styled.div`
  position: relative;
`;

export const FeatureList = styled.ul`
  list-style: none;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  /* overflow: scroll; */
  gap: 1.2rem;

  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */

  ::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`;

export const FeatureListItem = styled.li`
  display: flex;
  align-items: center;
  ${textSizes.SmallW1};
  /* padding: 0.8rem; */
  gap: 0.8rem;
  border: 0.1rem solid #e4e4e4;
  align-self: stretch;
  border-radius: 1.2rem;
  width: 15rem;
  flex: 0 0 15rem;
  min-width: 0;
  position: relative;
  min-height: 42px;
  padding-left: 52px;
  &:last-child {
    border-bottom: 0.1rem solid #e4e4e4 !important; //For handling case at review page dweb
  }
`;

export const ItemIconWrapper = styled.div`
  position: absolute;
  left: -1px;
  top: -1px;
  width: 42px;
  height: calc(100% + 2px);
  flex-shrink: 0;
  border: 1px solid transparent;
  border-radius: 12px;
  align-items: center;
  justify-content: center;
  display: flex;
`;

export const ItemDesc = styled.span`
  ${textSizes.SmallW1};
  color: #222222;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  padding-right: 6px;
`;

export const ItemDisc = styled.div`
  width: 0.6rem;
  height: 0.6rem;
  transform: rotate(45deg);
  background: linear-gradient(315deg, #f8cd46 0%, #f4a900 100%);
`;

export const Itemtext = styled.p`
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre;
`;

export const ArrowNext = styled.div`
  display: inline-block;
  position: absolute;
  top: 8px;
  right: -8px;
  left: unset;
  width: 24px;
  height: 24px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  z-index: 10;
  cursor: pointer;
  .arrowNextIcon {
    width: 10px;
    height: 10px;
    border-top: 2px solid #717171;
    border-right: 2px solid #717171;
    transform: rotate(45deg);
    margin-left: -4px;
  }
`;

export const ArrowPrev = styled.div`
  display: inline-block;
  cursor: pointer;
  position: absolute;
  top: 8px;
  left: -8px;
  width: 24px;
  height: 24px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  z-index: 10;
  .arrowPrevIcon {
    width: 10px;
    height: 10px;
    border-top: 2px solid #717171;
    border-right: 2px solid #717171;
    transform: rotate(-135deg);
    margin-left: 4px;
  }
`;
